export default "__VITE_ASSET__0966e469__"